// extracted by mini-css-extract-plugin
export var circle = "_gl-1";
export var exitConfirmationModal = "_gl-5";
export var iframe = "_gl-0";
export var offline = "_gl-3";
export var online = "_gl-2";
export var workstationSelectError = "_gl-4";